import React, {createContext} from "react";

const GettingStartedContext = createContext({
  lang: 'en_US',
  link: null,
  data: null,
  reloadResults: false,
  setReloadResults: () => {},

  setData: () => {},
  showResult: null,
  setShowResult: () => {},
  result: null,
  setResult: () => {},
  showDownloadPricing: null,
  setShowDownloadPricing: () => {},

  plane: null,
  setPlane: () => {},
  planes: [],
  setPlanes: () => {},
  plans: [],
  setPlans: () => {},
  plan: [],
  setPlan: () => {},
  ownerships: [],
  setOwnerships: () => {},
  ownership: null,
  setOwnership: () => {},
  location: [],
  setLocation: () => {},
  hours: [],
  setHours: () => {},
  testimonials: [],
  setTestimonials: () => {},
  staticBlock: false,
  setStaticBlock: () => {},

  question: null,
  setQuestion: () => {},
  submittedQuestions: [],
  setSubmittedQuestions: () => {},
  selectTestimonials: () => {},
  indexOfSubmittedQuestion: () => {},
  getNextQuestion: () => {},


  showSkip: false,
  setShowSkip: () => {},


  langString: () => {},
  getLink: () => {},
  isFr: () => {},
  isEn: () => {},
  formatNumber: () => {},
  getProperty: () => {},
  requestVariable: () => {},
  padLeadingZeros: () => {},
  scrollTo: () => {},
  showToolTip: () => {},
  showFooter: () => {},
  hideFooter: () => {}


});

export default GettingStartedContext;
